import React from 'react'
import { getFolderLink } from 'pages/Cms/PagesList/utils'
import { useHistory } from 'react-router-dom'
import FramedIcon from 'redesign/components/atoms/FramedIcon'
import { WikiPagesIcon } from 'redesign/components/atoms/Icon'
import ContentCard from '../content-card'
import type { WikiFolderCardProps } from './types'

const WikiFolderCard: React.FC<WikiFolderCardProps> = ({ folder, ownerId }) => {
  const history = useHistory()

  if (!folder) return null

  return (
    <ContentCard
      dataTestId="wiki-folder-card"
      header={{
        // TODO: Missing folder icon
        icon: <FramedIcon icon={WikiPagesIcon} isFilled />,
        title: folder?.name,
        overflowSingleLine: true,
      }}
      onClick={() => history.push(getFolderLink(folder, ownerId))}
    />
  )
}

export default WikiFolderCard
